/**
 * AUTO-GENERATED from schema.json — DO NOT EDIT
 * Source: Table (table)
 * Run `yarn workspace @library/cms-blocks cms:types` to regenerate
 */

import { z } from 'zod'
import { RichTextContentSchema } from '../../types/contentstack-zod'
import { RawCmsCtaSchema } from '../../cta'

export const TableFieldsSchema = z
  .object({
    heading: z.string().nullish(),
    heading_level: z.enum(['h2', 'h3']),
    body: RichTextContentSchema.nullish(),
    table_position: z.enum(['left', 'right']),
    cta: RawCmsCtaSchema.nullish(),
    columns: z.array(z.object({ header: z.string() }).passthrough()),
    rows: z.array(
      z
        .object({
          row_id: z.string(),
          cells: z.array(
            z.object({ value: z.string(), is_bold: z.boolean().nullish() }).passthrough(),
          ),
        })
        .passthrough(),
    ),
  })
  .passthrough()
